// extracted by mini-css-extract-plugin
module.exports = {"status":"index__status__2TEG5","approve":"index__approve__YpWqg","reject":"index__reject__3ZB4a"};